import {
  clActivityCreate,
  clActivityDetail,
  clActivityList,
  clActivityUpdate
} from '@/febos/servicios/api/activities.api';
import { listOptions } from '@/febos/servicios/api/opciones.api';
import { fileBinnacle } from '@/febos/servicios/api/dnt.api';

export async function createActivity({ commit }, { activity, kanbanId }) {
  const response = await clActivityCreate(activity);
  commit('SET_ACTIVITY', { activity: response, kanbanId });
}

export async function updateActivity({ commit }, { activityId, activity, kanbanId }) {
  const response = await clActivityUpdate(activityId, activity);
  commit('SET_ACTIVITY', { activity: response, kanbanId });
}

export async function changeActivityStatus(
  { commit },
  {
    activity,
    kanbanId,
    statusValue,
    statusName,
    companyStatusValue,
    companyStatusName
  }
) {
  commit('SET_ACTIVITY', {
    activity: { ...activity, statusValue, statusName },
    kanbanId,
    isUpdating: true
  });
  const activityUpdated = await clActivityUpdate(activity.id, {
    statusValue,
    statusName,
    companyStatusValue,
    companyStatusName
  });
  commit('SET_ACTIVITY', { activity: activityUpdated, kanbanId });
}

export async function fetchColumns({ commit }) {
  commit('SET_COLUMNS_LOADING', { loading: true });
  const { data: { opciones: options } } = await listOptions({
    grupoOpcion: 'estados-kanban',
    deshabilitado: 'no'
  });
  const columns = options
    .map((option) => ({
      id: option.opcionId,
      name: option.descripcion,
      value: option.valor,
      order: option.orden,
      ...JSON.parse(option.extra)
    }));
  commit('SET_COLUMNS', { columns });
}

export async function fetchActivities(
  { commit },
  { kanbanId, referenceId, filters = '' }
) {
  const activities = await clActivityList(referenceId, filters);
  commit('SET_ACTIVITIES', { activities, kanbanId });
}

export async function fetchActivity({ commit }, { kanbanId, activityId }) {
  commit('SET_ACTIVITY_UPDATING', { activityId, kanbanId, isUpdating: true });
  const activity = await clActivityDetail(activityId);
  commit('SET_ACTIVITY', { activity, kanbanId });
}

export async function fetchActivityBinnacle({ commit }, { activityId }) {
  commit('SET_BINNACLE_LOADING', { activityId, isLoading: true });
  const { data: { bitacora: binnacle } } = await fileBinnacle({ febosId: activityId });
  const items = binnacle.map((item) => ({
    id: item.bitacoraId,
    title: item.usuarioNombre,
    subtitle: item.mensaje,
    date: item.fecha,
    variant: 'primary',
    icon: 'InfoIcon'
  }));
  commit('SET_BINNACLE', { activityId, items });
}

export async function getCsvActivities({ commit }, activities) {
  try {
    commit('SET_COLUMNS_LOADING', { loading: true });

    const data = activities.map((item) => ({
      Categoría: item.categoryValue,
      'Compañía ID': item.companyId,
      'Compañía Estado': item.companyStatusValue,
      'Compañía Nombre': item.companyStatusName,
      'Fecha de Creación': item.createdAt,
      ID: item.id,
      Nombre: item.name,
      Prioridad: item.priority,
      'Referencia ID': item.referenceId,
      'Referencia Elemento Número': item.referenceElementNumber,
      'Referencia Elemento Tipo': item.referenceElementType,
      'Referencia Tipo': item.referenceType,
      'Estado Nombre': item.statusName,
      'Estado Valor': item.statusValue,
      'Usuario ID': item.targetUserId,
      'Usuario Nombre': item.targetUserName,
      'Fecha de Actualización': item.updatedAt,
      'Fecha de Vencimiento': item.expiredAt
    }));

    const keys = Object.keys(data[0]);
    const rowData = [keys.join(','), data.map((row) => keys.map((key) => row[key]).join(',')).join('\n')].join('\n');

    const universalBOM = '\uFEFF';
    const a = window.document.createElement('a');
    a.setAttribute('href', `data:text/csv; charset=utf-8,${encodeURIComponent(universalBOM + rowData)}`);
    window.open(a);
  } finally {
    commit('SET_COLUMNS_LOADING', { loading: false });
  }
}
